import { Container, Button, Form, Alert, Modal, Table } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper, Stycke, StyckeCompact } from "../ContentStyles";
import { FaFilePdf, FaBars, FaPen, FaBarcode, FaEraser, FaTrash } from 'react-icons/fa';
import React, { useMemo, useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, { CallAPI, Loading, SpinnerX, Check } from '../../services/useBackend';
import { Link } from "react-router-dom";
import { Branding } from '../../services/misc';

import { DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO } from '../../services/misc';

export default function MyComponent() {
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText, setResultText] = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

    const { loading, data, Refresh } = useBackend('/api/admin/products');
    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    var pageIndex = parseInt(searchParams.get('pageindex'), 10) || 0;
    var pageSize = parseInt(searchParams.get('pagesize'), 10) || 25;

    const [pagination, setPagination] = useState({ pageIndex: pageIndex, pageSize: pageSize });
    const [editProductModalshow, setEditProductModalshow] = useState(false);
    const initModal = () => { return setEditProductModalshow(!editProductModalshow) }

    const [editProductData, setEditProductData] = useState({ "Guid": "00000000-0000-0000-0000-000000000000", "Name": "", "Description": "", "EAN": "", "Price": 0, "Vat": 25, "State": 1, "AllowManualRegistration": true, "ShowOnPricelist": false, "ProductGroup": {"Guid": "00000000-0000-0000-0000-000000000000", "Name": ""} });

    const editProductHandler = (event, rowData) => {
        setResultVisible(false);
        setEditProductData(rowData.original)
        setEditProductModalshow(!editProductModalshow);
    }

    const addProductHandler = (event) => {
        event.preventDefault();
        setResultVisible(false);
        setEditProductData({ "Guid": "00000000-0000-0000-0000-000000000000", "Name": "", "Description": "", "EAN": "", "Price": 0, "Vat": 25, "State": 1, "AllowManualRegistration": true, "ShowOnPricelist": false, "ProductGroup": {"Guid": "00000000-0000-0000-0000-000000000000", "Name": ""} })
        setEditProductModalshow(!editProductModalshow);
    }



    const columns = useMemo(() => [
        { size: 40, accessorKey: 'EAN', header: 'EAN', enableColumnActions: false },
        { size: 40, accessorKey: 'Name', header: 'Name' },
        { size: 40, accessorKey: 'ProductGroupName', header: 'Produktgrupp' },
        { size: 20, accessorKey: 'Price', header: 'Pris', enableOrdering: false, enablePinning: false, enableColumnActions: true },

        {
            size: 20, header: 'Manuell registrering', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.AllowManualRegistration} />),
        },

        {
            size: 20, header: 'Visa på prislista', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.ShowOnPricelist} />),
        },
    ]
    );

    const initialState = { density: 'compact', columnVisibility: { 'Manuell registrering': false, 'Visa på prislista': false, 'Price': false }, pagination: pagination };

    const state = { pagination: pagination };

    if (!loading && !registerDataLoading) {
        return (
            <ContentWrapper>

                <ModalProductEdit show={editProductModalshow} onHide={initModal} editProductData={editProductData} registerData={registerData} refreshFunction={()=> { Refresh();}} ></ModalProductEdit>

                <Container>
                    <Sida>
                        <MaterialReactTable columns={columns} data={data.Products} onPaginationChange={setPagination} state={state} initialState={initialState}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage: "Rader" }}
                            renderTopToolbarCustomActions={() => (<Rubrik>Varor</Rubrik>)}

                            muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => { editProductHandler(event, row); }, sx: { cursor: 'pointer' },
                            })}
                        />

                        <div className="product-actions">
                            <Button
                                className="QmeButton"
                                style={{ backgroundColor: Branding().ButtonColor }}
                                onClick={addProductHandler}
                            >
                                Lägg till vara
                            </Button>

                            <Button
                                className="QmeButton QmeButton--secondary"
                                variant="outline-secondary"
                                onClick={() => navigate("/productgroups")}
                            >
                                Se varugrupper
                            </Button>
                        </div>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);
    }
}

export function ModalProductEdit(props) {
    const [resultText,    setResultText]    = useState(":)");
    const [resultVariant, setResultVariant] = useState("notset");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);

    const [saving, setSaving] = useState(false);

    var typingTimeout = null;

    async function handleSave() {
        setSaving(true);
        setResultText("");
        setResultVisible(false);
        const ProductForm = document.getElementById('ProductForm');
        const formData = new FormData(ProductForm);

        const formDataObj = Object.fromEntries(formData.entries());
        formDataObj.ShowOnPricelist = formData.has('ShowOnPricelist') ? true : false;
        formDataObj.AllowManualRegistration = formData.has('AllowManualRegistration') ? true : false;

        if (props.editProductData.Guid === "00000000-0000-0000-0000-000000000000") {
            let { resultVariant, resultVisible, resultText, errorsException } = await CallAPI('/api/admin/products', 'POST', JSON.stringify(formDataObj));
            if (resultVariant != "success") {
                setResultVariant(resultVariant);
                setResultText(resultText);
                setResultVisible(resultVisible);
            } else {
                props.onHide();
            }
        } else {
            let { resultVariant, resultVisible, resultText, errorsException } = await CallAPI('/api/admin/product/' + props.editProductData.Guid, "PATCH", JSON.stringify(formDataObj));
            if (resultVariant != "success") {
                setResultVariant(resultVariant);
                setResultText(resultText);
                setResultVisible(resultVisible);
            }
        }
        props.refreshFunction();
        setSaving(false);
    }

    async function handleRemove() {
        setSaving(true);

        let { resultVariant, resultVisible, resultText, errorsException } = await CallAPI('/api/admin/product/' + props.editProductData.Guid, "DELETE", "{}");
        if (errorsException) {
            setResultVariant(resultVariant);
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {
            props.refreshFunction();
            props.onHide();
        }
        setSaving(false);
    }    

    async function handleGenerateEAN() {
        setSaving(true);
        let { jsondata } = await CallAPI('/api/admin/GenerateEAN/', "PUT", "{}");
        document.getElementById("EAN").value = jsondata.EAN;
        setSaving(false);
    }

    function handleChange(event) {
        if (props.editProductData.Guid != "00000000-0000-0000-0000-000000000000") {
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(handleSave, 475);
        }
    }    

    function getOptions(object) {
        return object.map((key) => {
            return <option key={key.Guid} value={key.Guid}>{key.Name}</option>;
        });
    }    

    async function handleRemoveEAN(ProductGuid, EANGuid) {
        setResultVisible(false);
        setSaving(true);
        console.log(EANGuid);
        let { resultVisible, resultText, errorsException, jsondata } = await CallAPI('/api/admin/Product/' + ProductGuid + '/EAN/' + EANGuid, "DELETE", "{}");
        props.refreshFunction();
        props.editProductData.ProductVariants = jsondata.ProductVariants;
        setSaving(false);

        console.log("resultVisible: " + resultVisible);

        if (!resultVisible) {
            setResultVisible(false);
        } else {
            setResultVisible(true);
            setResultText(resultText);
        }
    }

    async function handleAddEAN(ProductGuid) {
        setResultVisible(false);
        setSaving(true);

        const VariantEAN = document.getElementById('VariantEAN').value;
        const VariantDescription = document.getElementById('VariantDescription').value;
        const formDataObj = { EAN: VariantEAN, Description: VariantDescription };
        let { resultVisible, resultText, errorsException, jsondata } = await CallAPI('/api/admin/Product/' + ProductGuid + '/EAN/', 'POST', JSON.stringify(formDataObj));
        props.refreshFunction();
        props.editProductData.ProductVariants = jsondata.ProductVariants;

        //props.editProductData.ProductVariants = jsondata.ProductVariants;
        //props.setEditProductData(props.editProductData);

        console.log("resultVisible: " + resultVisible);
        if (!resultVisible) {
            setResultVisible(false);
            document.getElementById('VariantEAN').value = "";
            document.getElementById('VariantDescription').value = "";
        } else {
            setResultVisible(true);
            setResultText(resultText);
        }

        setSaving(false);
    }

    async function handleGeneratePriceTag(ProductGuid) {
        console.log(ProductGuid);
        window.open("/api/Report/pricetag/" + ProductGuid, "_blank")
    }    

     
        if (props.editProductData != null) {
        return (
                //{editProductData != null &&
                    <Modal show={props.show} onHide={()=>props.onHide()}>
                        <Modal.Header closeButton>

                            {props.editProductData.Guid == "00000000-0000-0000-0000-000000000000" ? (<Modal.Title>Ny vara</Modal.Title>) : (<Modal.Title>{props.editProductData.Name}</Modal.Title>)}

                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleSave} id="ProductForm">

                                <Form.Group className="mb-3" >
                                    <Form.Label>Namn</Form.Label>
                                    <Form.Control type="text" name="Name" placeholder="Produktnamn" defaultValue={props.editProductData.Name} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Produktbeskrivning</Form.Label>
                                    <Form.Control type="text" name="Description" placeholder="Produktbeskrivning" defaultValue={props.editProductData.Description} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>EAN (Streckkoder)</Form.Label>

                                    {props.editProductData.Guid == "00000000-0000-0000-0000-000000000000" ? (
                                        <div className="d-flex">
                                            <Form.Control type="text" id="EAN" name="EAN" placeholder="EAN" defaultValue={props.editProductData.EAN} onChange={handleChange} />&nbsp;
                                            <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={handleGenerateEAN} disabled={props.editProductData.Guid == "00000000-0000-0000-0000-000000000000" ? (false) : (true)}>Generera</Button>
                                        </div>
                                    ) : (
                                        <div>
                                            <Table responsive="sm">
                                                <tbody>
                                                    {props.editProductData.ProductVariants.map((state) => {
                                                        return <tr key={state.Id}>
                                                            <td>{state.EAN}</td>
                                                            <td>{state.Description}</td>
                                                            <td><span className='sub' ProductData={state} onClick={() => handleRemoveEAN(props.editProductData.Guid, state.Guid)}><FaTrash /></span></td>
                                                            <td><span className='sub' ProductData={state} onClick={() => handleGeneratePriceTag(state.Guid)} ><FaBarcode /></span></td>
                                                        </tr>;
                                                    })}
                                                </tbody>
                                            </Table>

                                            <div className="d-flex">
                                                <Form.Control type="text" id="VariantEAN" name="VariantEAN" placeholder="EAN/Streckkod" />&nbsp;<Form.Control type="text" id="VariantDescription" name="VariantDescription" placeholder="Färg/Smak/Storlek" />&nbsp;
                                                <Button className="QmeButton" variant="primary" type="button" onClick={() => handleAddEAN(props.editProductData.Guid,)} style={{ whiteSpace: "nowrap", minWidth: "auto", backgroundColor: Branding().ButtonColor }}>Lägg till</Button>
                                            </div>
                                        </div>
                                    )}

                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Produktgrupp</Form.Label>
                                    {/* <Form.Select name="ProductGroupId" defaultValue={editProductData.Guid=="00000000-0000-0000-0000-000000000000" ? (registerData.productGroups.find((element) => element.Default == true).Id):(editProductData.ProductGroupId)} onChange={handleChange}></Form.Select> */}
                                    <Form.Select name="ProductGroupGuid" defaultValue={props.editProductData.ProductGroup.Guid} onChange={handleChange}>
                                        <option value={0}>------</option>
                                        {getOptions(props.registerData.productGroups)}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Pris inkl. moms</Form.Label>
                                    <Form.Control type="text" name="Price" placeholder="Produktpris" defaultValue={props.editProductData.Price} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Momssats</Form.Label>
                                    <Form.Select name="Vat" defaultValue={props.editProductData.Vat} onChange={handleChange}>
                                        <option value="6">6% Tidningar, böcker, taxi, buss, flyg, tåg i Sverige</option>
                                        <option value="12">12%  Livsmedel, restaurangbesök, hotell, konstverk</option>
                                        <option value="25">25% Standard</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Check
                                        type="switch"
                                        name="ShowOnPricelist"
                                        id="ShowOnPricelist"
                                        label="Visa på prislista"
                                        defaultChecked={props.editProductData.ShowOnPricelist}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Check
                                        type="switch"
                                        name="AllowManualRegistration"
                                        id="AllowManualRegistration"
                                        label="Tillåt manuell registrering av varan i app"
                                        defaultChecked={props.editProductData.AllowManualRegistration}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" hidden={!saving}>
                                    <SpinnerX />
                                </Form.Group>

                                <Form.Group className="mb-3" hidden={!resultVisible}>
                                    <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                                </Form.Group>
                            </Form>


                        </Modal.Body>
                        <Modal.Footer>
                            {props.editProductData.Guid == "00000000-0000-0000-0000-000000000000" ? (
                                <>
                                    <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={handleSave}>Lägg till varan</Button>
                                    <Button variant="danger" onClick={() => props.onHide()}>Avbryt</Button>
                                </>
                            ) : (
                                <>
                                    <Button variant="danger" type="button" onClick={handleRemove}>Ta bort varan</Button>
                                    <Button variant="secondary" onClick={() => props.onHide()}>Stäng</Button>
                                </>
                            )}
                        </Modal.Footer>
                    </Modal>
                
        );
    }
}